export default {
      id: "cross-usage",
      viewBox: "0 0 16 16",
      url: "/" + "img/marilyn-ui.svg#cross",
      toString: function () {
        return this.url;
      }
    }